import { CREDIT_PARAMS_FORMATTER_FUNC } from '@perxis-auto/credit-sdk';

export const DEFAULT_CREDIT_PARAMS_FORMATTER: CREDIT_PARAMS_FORMATTER_FUNC = choice => {
  return {
    currency: 'RUB',
    ...choice,
  };
};

export const CURRENCY_MAP = {
  RUB: '₽',
  USD: '$',
  EUR: '€',
  BYN: 'Br',
  UZS: 'so’m',
  KZT: '₸',
  IDR: 'Rp',
} as Record<string, string>;
